module.exports = __webpack_public_path__ + "static/media/ImgAvatar.160a5c3e.svg";